<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        
                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="yearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col lg="2" md="2" cols="6">
                                            <v-btn class="bg-brand" type="submit" ref="searchButton">
                                                Search
                                            </v-btn                                           >
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Earned Leave Register Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="pa-2">
                                <v-row >

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>

                                            </v-btn-group>
                                        </div>
                                    </v-col>
                                    
                                </v-row>

                                <v-card class="my-2 rounded-md">
                                    <v-card-title class="bg-primary text-white text-center">
                                        <div class="w-100">
                                            <div class="text-h5 font-weight-bold">
                                                Leave Earned Register Report {{ year.value.value? `for ${year.value.value}` : " "}}
                                            </div>
                                        </div>
                                    </v-card-title>
                                </v-card>

                                <v-data-table
                                :headers="headers"
                                :items="getSchema"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                class="custom-bordered-table"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item="{ item, index }">
                                        <tr>
                                            <td class="text-left">{{ ++index }}</td>
                                            <td class="text-left">{{ item.employee_code }}</td>
                                            <td class="text-right">{{ item.employee_name }}</td>
                                            <td class="text-right">{{ item.entitled }}</td>
                                            <td class="text-right">{{ item.used }}</td>
                                            <td class="text-right">{{ item.carried_forward }}</td>
                                            <td class="text-right">{{ item.remaining }}</td>
                                        </tr>
                                    </template>

                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Employee Code", key: "employee_code", align: "center", sortable: false },
            { title: "Employee Name", key: "employee_name", align: "center", sortable: false, },
            { title: "Entitled", key: "entitled", align: "center", sortable: false, width: "100px" },
            { title: "Used", key: "used", align: "center", sortable: false, width: "100px" },
            { title: "Carried Forward", key: "carried_forward", align: "center", sortable: false, width: "150px" },
            { title: "Remaining", key: "remaining", align: "center", sortable: false, width: "120px" },
        ],
    }),

    watch: {},
    computed: {
        getSchema() {
            return this.$store.getters.getLeaveEarnedRegisterReport;
        },

        yearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();
            const years = [];

            for (let y = startYear; y <= currentYear; y++) {
                years.push(y);
            }

            return years;
        },
    },
    setup() {
        const { handleSubmit } = useForm({
            validationSchema: yup.object({
                // from_date: yup.date().required().label("From Date"),
                // to_date: yup.date().required().label("To Date"),
            }),
        });

        const year = useField("year");

        const errorMessages = ref("");
        const loading = ref(false);
        const store = useStore();
        const submit = handleSubmit((values) => {
            loading.value = true;
            values.year = formattedDate(year.value.value);
            store
                .dispatch("getLeaveEarnedRegisterReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            year,
            errorMessages,
            loading,
        };
    },

    methods: {
        formattedDate,

        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = [ "#SL", "Employee code", "Employee Name", "Entitled", "Used", "Carried Forward", "Remaining" ];
            const rows = this.getSchema.map((item) => [ serialNumber++, item.employee_code, item.employee_name, item.entitled, item.used, item.carried_forward, item.remaining ]);
            this.$exportTableToPDF( columns, rows, "Leave Earned Register Report", "leave_earned_register_report_" + this.$fileDate());
        },

        exportToExcel() {
            var data = [[ "#SL", "Employee code", "Employee Name", "Entitled", "Used", "Carried Forward", "Remaining"]];
            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.employee_code, item.employee_name, item.entitled, item.used, item.carried_forward, item.remaining ]);
            });
            this.$exportTableToExcel(data, "leave_earned_register_report_" + this.$fileDate());
        },
        
        exportToCSV() {
            var data = [[ "#SL", "Employee code", "Employee Name", "Entitled", "Used", "Carried Forward", "Remaining"]];
            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.employee_code, item.employee_name, item.entitled, item.used, item.carried_forward, item.remaining  ]);
            });

            this.$exportTableToCSV(data, "leave_earned_register_report_" + this.$fileDate());
        },
    },

    mounted() {
        this.$nextTick(() => {
            // this.$refs.searchButton.$el.click();
            // this.from_date.value.value = new Date();
            // this.to_date.value.value = new Date();
        });   
    },
};
</script>

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}

</style>
